import React from "react";
import Sheet from "react-modal-sheet";
import { IonItem } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setLearningBottomSheet } from "redux/container/userSlice";
import { useNavigate } from "react-router-dom";

export default function BottomSheet({ post }) {
	const ref = React.useRef();
	const isOpenBottomSheet = useSelector(
		(state) => state.user.learningBottomSheet
	);
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const handleShare = () => {
		navigate(`/create-article`);
		dispatch(setLearningBottomSheet(false));
	};

	return (
		<div>
			<Sheet
				className='bottom-sheet'
				initialSnap={1}
				ref={ref}
				isOpen={isOpenBottomSheet}
				snapPoints={[200, 200, 100, 0]}
				onClose={() => dispatch(setLearningBottomSheet(false))}>
				<Sheet.Container>
					<Sheet.Header />
					<Sheet.Content>
						<IonItem button onClick={handleShare} lines='none'>
							<span className='py-[5px]'>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									width='24'
									height='24'
									viewBox='0 0 24 24'
									fill='none'
									stroke='currentColor'
									strokeWidth='2'
									strokeLinecap='round'
									strokeLinejoin='round'>
									<path d='M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7'></path>
									<path d='M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z'></path>
								</svg>
							</span>
							<p className='text-14 font-semibold text-black-1000 pl-2'>
								Create New Article
							</p>
						</IonItem>
					</Sheet.Content>
				</Sheet.Container>

				<Sheet.Backdrop
					onClick={() => dispatch(setLearningBottomSheet(false))}
				/>
			</Sheet>
		</div>
	);
}
